// Ouverture d'un aperçu de rapport dans un NOUVEL ONGLET, avec une barre d'outils
// « Imprimer » + « Enregistrer en PDF » (nom de fichier suggéré legacy).
// Appelable depuis n'importe quel composant (menu Impression + modals).

function escAttr(s) {
  return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/"/g, "&quot;");
}
function escHtml(s) {
  return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

function buildPageHtml(objUrl, title, fileName) {
  const T = escHtml(title || "Rapport");
  const OBJ = escAttr(objUrl);
  const NAME = escAttr(fileName || "rapport.pdf");
  return `<!DOCTYPE html>
<html lang="fr"><head><meta charset="utf-8"><title>${T}</title>
<style>
  html,body{margin:0;height:100%;font-family:Arial,Helvetica,sans-serif;background:#525659;}
  .tb{display:flex;align-items:center;gap:10px;background:#2b2b2b;color:#fff;padding:8px 14px;font-size:13px;}
  .tb .t{font-weight:bold;margin-right:auto;}
  .tb button{background:#003366;color:#fff;border:none;border-radius:3px;padding:6px 14px;font-size:13px;cursor:pointer;}
  .tb button:hover{background:#004a94;}
  iframe{width:100%;height:calc(100% - 41px);border:none;background:#525659;}
</style></head>
<body>
  <div class="tb">
    <span class="t">${T}</span>
    <button type="button" onclick="doPrint()">Imprimer</button>
    <button type="button" onclick="doSave()">Enregistrer en PDF</button>
  </div>
  <iframe id="v" src="${OBJ}"></iframe>
  <script>
    var OBJ=${JSON.stringify(objUrl)}, NAME=${JSON.stringify(fileName || "rapport.pdf")};
    function doPrint(){ try{ var w=document.getElementById('v').contentWindow; w.focus(); w.print(); }catch(e){ window.print(); } }
    async function doSave(){
      try{
        if(window.showSaveFilePicker){
          var r=await fetch(OBJ); var b=await r.blob();
          var h=await window.showSaveFilePicker({suggestedName:NAME, types:[{description:'Document PDF',accept:{'application/pdf':['.pdf']}}]});
          var wr=await h.createWritable(); await wr.write(b); await wr.close(); return;
        }
      }catch(e){ if(e && e.name==='AbortError') return; }
      var a=document.createElement('a'); a.href=OBJ; a.download=NAME; document.body.appendChild(a); a.click(); a.remove();
    }
  </script>
</body></html>`;
}

export async function openReport(payload) {
  const { url, title, fileName } = payload || {};
  if (!url) return;
  // Ouvrir l'onglet SYNCHRONEMENT (sinon bloqué par l'anti-popup).
  const tab = window.open("", "_blank");
  if (!tab) {
    // Anti-popup actif : repli direct sur le PDF.
    window.open(url, "_blank", "noopener,noreferrer");
    return;
  }
  tab.document.write(
    `<!DOCTYPE html><html lang="fr"><head><meta charset="utf-8"><title>${escHtml(title || "Rapport")}</title></head>` +
    `<body style="margin:0;font-family:Arial,Helvetica,sans-serif;display:flex;align-items:center;justify-content:center;height:100vh;color:#555">Chargement du rapport…</body></html>`
  );
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error("HTTP " + res.status);
    const blob = await res.blob();
    const objUrl = URL.createObjectURL(blob);
    tab.document.open();
    tab.document.write(buildPageHtml(objUrl, title, fileName));
    tab.document.close();
  } catch (e) {
    try {
      tab.document.open();
      tab.document.write(
        `<body style="margin:0;font-family:Arial;display:flex;align-items:center;justify-content:center;height:100vh;color:#b00">Impossible de charger le rapport.</body>`
      );
      tab.document.close();
    } catch (_) { /* onglet fermé */ }
  }
}

// Nom de fichier suggéré legacy (frmCRV) :
//   Nomparlant_{id (noref ou noseq)}_{initiales}.pdf
// initiales = 1re lettre prénom + 1re lettre nom du requérant (adda204 + adda202).
export function buildReportName(base, id, prenom, nom) {
  const ini =
    ((prenom || "").trim()[0] || "").toUpperCase() +
    ((nom || "").trim()[0] || "").toUpperCase();
  const parts = [base];
  const idv = (id || "").toString().trim();
  if (idv) parts.push(idv);
  if (ini) parts.push(ini);
  return parts.join("_") + ".pdf";
}
